import { useEffect, useState } from "react";
import CreateMeeting from "../../components/meeting/CreateMeeting";
import UpcomingMeetings from "../../components/meeting/UpcomingMeetings";
import Invitations from "../../components/meeting/Invitations";
import "./style.css";
import { useSelector } from "react-redux";

function Meeting() {
    const [meetings, setMeetings] = useState([]);
    const [invitations, setInvitations] = useState([]);
    const user = useSelector(state => state.profil);

    useEffect(() => {
        fetchMeetings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchMeetings = async () => {
        const token = sessionStorage.getItem("token");

        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/me/upcoming`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const res = await req.json();

        // réunions confirmées
        const confirmed = res.filter(m =>
            m.owner === user._id ||
            m.participants.some(p => p.user === user._id && p.status === "accepted")
        );

        // invitations
        const pending = res.filter(m =>
            m.participants.some(p => p.user === user._id && p.status === "pending")
        );

        setMeetings(confirmed);
        setInvitations(pending);
    };

    return (
        <div className="page_meeting">
            <CreateMeeting onCreated={fetchMeetings} />

            <UpcomingMeetings
                meetings={meetings}
                onUpdate={fetchMeetings}
            />

            <Invitations
                invitations={invitations}
                onUpdate={fetchMeetings}
            />

        </div>
    );
}

export default Meeting;